import React, { useState, createContext, useMemo } from 'react';
import logComponent from '../common/logComponent';

// create context
const CardLongestResponseContext = createContext(null);
const timeRanges = [
  'Past 7 days',
  'Past 30 days'
];

// declare provider component
const CardLongestResponseProvider = ({ children }) => {
  const [longestResponse, setLongestResponse] = useState(null);
  const [longestResponseMonitoredIndividualsAndUnits, setLongestResponseMonitoredIndividualsAndUnits] = useState(null);
  const [longestResponseTimeRange, setLongestResponseTimeRange] = useState(timeRanges[0]);
  const [longestResponseLoading, setLongestResponseLoading] = useState(null);
  const [longestResponseError, setLongestResponseError] = useState(null);


  const setTheLongestResponse = (longestResponse) => {
    if (logComponent('CardLongestResponseContext')) { console.debug('CardLongestResponseContext setTheLongestResponse'); }
    let newLongestResponse = longestResponse ? [ ...longestResponse ] : null;
    setLongestResponse(newLongestResponse);
  }

  const setTheLongestResponseMonitoredIndividualsAndUnits = (theLongestResponseMonitoredIndividualsAndUnits) => {
    if (logComponent('CardLongestResponseContext')) { console.debug('CardLongestResponseContext setTheLongestResponseMonitoredIndividualsAndUnits'); }
    let newLongestResponseMonitoredIndividualsAndUnits = theLongestResponseMonitoredIndividualsAndUnits ? [ ...theLongestResponseMonitoredIndividualsAndUnits ] : null;
    setLongestResponseMonitoredIndividualsAndUnits(newLongestResponseMonitoredIndividualsAndUnits);
  }
  
  const setTheLongestResponseTimeRange = (timeRange) => {
    if (logComponent('CardLongestResponseContext')) { console.debug('CardLongestResponseContext setTheLongestResponseTimeRange'); }
    let newTimeRange = timeRange;
    setLongestResponseTimeRange(newTimeRange);
  }

  const setTheLongestResponseLoading = (longestResponseLoading) => {
    if (logComponent('CardLongestResponseContext')) { console.debug('CardLongestResponseContext setTheLongestResponseLoading'); }
    let newLongestResponseLoading = longestResponseLoading;
    setLongestResponseLoading(newLongestResponseLoading);
  }

  const setTheLongestResponseError = (longestResponseError) => {
    if (logComponent('CardLongestResponseContext')) { console.debug('CardLongestResponseContext setTheLongestResponseError'); }
    let newLongestResponseError = longestResponseError;
    setLongestResponseError(newLongestResponseError);
  }



  const cardState = useMemo(() => ({
    timeRanges,
    longestResponse,
    longestResponseMonitoredIndividualsAndUnits,
    longestResponseTimeRange,
    longestResponseLoading,
    longestResponseError,
    setLongestResponse: setTheLongestResponse,
    setLongestResponseMonitoredIndividualsAndUnits: setTheLongestResponseMonitoredIndividualsAndUnits,
    setLongestResponseTimeRange: setTheLongestResponseTimeRange,
    setLongestResponseLoading: setTheLongestResponseLoading,
    setLongestResponseError: setTheLongestResponseError
  }), [
    timeRanges,
    longestResponse,
    longestResponseMonitoredIndividualsAndUnits,
    longestResponseTimeRange,
    longestResponseLoading,
    longestResponseError
]);

  return (
    <CardLongestResponseContext.Provider value={ cardState }>
      {children}
    </CardLongestResponseContext.Provider>
  );
}

// export provider and context
export { CardLongestResponseContext, CardLongestResponseProvider };